import { Control } from 'react-hook-form';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FormTextField } from '../../../../../component/form/FormTextField';
import { FormDatePicker } from '../../../../../component/form/FormDatePicker';
import { KsvSearchFormValues } from './useKsvSearchForm';

interface Props {
  control: Control<KsvSearchFormValues>;
  canEditAddress: boolean;
}

export function PrivateKsvSearchFields({ control, canEditAddress }: Props) {
  const { t } = useTranslation();
  return (
    <Grid container spacing={1} sx={{ mb: 1 }}>
      <Grid item xs={4}>
        <FormTextField
          control={control}
          name="firstName"
          label={t('customers.edit.personalData.firstName')}
          required
          fullWidth
        />
      </Grid>
      <Grid item xs={4}>
        <FormTextField
          control={control}
          name="lastName"
          label={t('customers.edit.personalData.lastName')}
          required
          fullWidth
        />
      </Grid>
      <Grid item xs={4}>
        <FormDatePicker
          control={control}
          name="birthDate"
          label={t('customers.edit.personalData.birthDate')}
          required
        />
      </Grid>
      <Grid item xs={5}>
        <FormTextField
          control={control}
          name="street"
          label={t('customers.edit.personalData.addressStreet')}
          fullWidth
          disabled={!canEditAddress}
        />
      </Grid>
      <Grid item xs={2}>
        <FormTextField
          control={control}
          name="houseNumber"
          label={t('customers.edit.personalData.addressHouseNumber')}
          fullWidth
          disabled={!canEditAddress}
        />
      </Grid>
      <Grid item xs={2}>
        <FormTextField
          control={control}
          name="zipCode"
          label={t('customers.edit.personalData.addressPostalCode')}
          fullWidth
          disabled={!canEditAddress}
        />
      </Grid>
      <Grid item xs={3}>
        <FormTextField
          control={control}
          name="city"
          label={t('customers.edit.personalData.addressCity')}
          fullWidth
          disabled={!canEditAddress}
        />
      </Grid>
    </Grid>
  );
}
